export default __webpack_public_path__ + "static/media/close.5fddf773.svg";